module.exports = __webpack_public_path__ + "media/src/assets/captains-4d77f68850859a7f996566b5c40b1656.png";